
import React from "react";
import "../Features/features.css";

import feature1 from "../../assets/images/feature/beach-umbrella.png";
import feature2 from "../../assets/images/feature/deal.png";
import feature3 from "../../assets/images/feature/location.png";
import feature4 from "../../assets/images/feature/medal.png";

import { Card, Container, Row } from "react-bootstrap";

const Features = () => {
  const featureList = [
    {
      id: 0,
      image: feature1,
      title: "Explore Beautiful Places",
      des: "From Gujarat to Diu — your dream destination starts here.",
    },
    {
      id: 1,
      image: feature2,
      title: "Best Travel Deals",
      des: "From budget trips to luxury packages — our prices are pocket-friendly.",
    },
    {
      id: 2,
      image: feature3,
      title: "Book from Home",
      des: "Easy planning with online booking and instant confirmation.",
    },
    {
      id: 3,
      image: feature4,
      title: "Trusted by Travelers",
      des: "Over 1000+ happy travelers. Travel safely with us.",
    },
  ];

  return (
    <section className="feature-section">
      <Container>
        <Row>
          <div className="features-scroll">
            {featureList.map((feature) => (
              <Card key={feature.id} className="feature-card text-center">
                <Card.Img
                  variant="top"
                  src={feature.image}
                  alt={feature.title}
                  className="mx-auto mt-3"
                  style={{ width: "64px", height: "64px", objectFit: "contain" }}
                />
                <Card.Body>
                  <Card.Title className="h6 fw-bold">{feature.title}</Card.Title>
                  <Card.Text className="small">{feature.des}</Card.Text>
                </Card.Body>
              </Card>
            ))}
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default Features;
